const getters = {
  language: state => state.app.language,
  size: state => state.app.size,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  userId: state => state.user.userid,
  firstName: state => state.user.firstName,
  lastName: state => state.user.lastName,
  remark: state => state.user.remark,
  status: state => state.user.status,
  googleVerifierKey: state => state.user.googleVerifierKey,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js